import { useCartState } from '@/core/application/providers/StateMachineProvider';
import { ShoppingBag } from 'lucide-react';
import Link from 'next/link';
import { MouseEventHandler, useState } from 'react';
import CartPreview from '@/components/cart/CartPreview';

interface Props {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  classNames?: string;
}

const CartButtonLink = ({ onClick }: Props) => {
  const { isEmpty, itemCount } = useCartState();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const _classNames = isPreviewOpen ? 'bg-orange-700 scale-95' : '';

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsPreviewOpen(true);
    onClick?.(e);
  };

  return (
    <>
      <Link
        href="/cart"
        onClick={handleClick}
        className={`bg-orange-600 text-white shadow-lg hover:shadow-xl px-3 py-3 rounded-full flex justify-center items-center font-medium hover:bg-orange-700 transition-all duration-200 ${_classNames} relative`}>
        <ShoppingBag className="w-4 h-4" />
        {!isEmpty && (
          <div className="absolute -top-2 -right-2 bg-green-500 text-white min-w-[20px] h-5 rounded-full flex items-center justify-center text-xs font-bold border-2 border-white shadow-lg animate-in fade-in zoom-in duration-200">
            {itemCount < 100 ? itemCount : '99+'}
          </div>
        )}
      </Link>
      {isPreviewOpen && <CartPreview onClose={() => setIsPreviewOpen(false)} />}
    </>
  );
};

export default CartButtonLink;
